t = require('views/internal/teacup-with-helpers')('board_menu_about_this_board')

actionsPartial = t.renderable (canComment, canVote, headerKey) ->
  if canComment || canVote
    t.div '.about-this-board-actions-section', ->
      t.h2 '.small-caps', ->
        t.format headerKey
      t.ul '.pop-over-list.inset', ->
        if canComment
          t.li ->
            t.span '.icon-sm.icon-comment'
            t.format 'comment-on-cards'
        if canVote
          t.li ->
            t.span '.icon-sm.icon-vote'
            t.format 'vote-on-cards'

module.exports = t.renderable ({ isLoggedIn, isAdmin, canComment, canVote, commentHeader, votingHeader,
permissionsHierarchy }) ->

  # Admin/s profile
  t.div '.about-this-board-section', ->
    t.h3 ->
      t.span '.icon-lg.icon-member'
      t.raw '&nbsp;'
      t.format 'made-by'

    t.div '.js-made-by'

    t.div '.about-this-board-admin-section', ->
      t.span '.admin-section', ->
        t.ul '.board-admins-facepile', ->
          t.span '.js-made-by-multi'
          t.a '.admin-count.about-this-board-pile-button.pile.js-fill-board-admin-count', { href: '#' }, ->
            t.span '.admin-count-notifications'


  # Commenting and voting permissions
  if canComment || canVote
    t.div '.about-this-board-section', ->
      t.hr()
      if isAdmin
        if permissionsHierarchy == 'equal'
          actionsPartial(canComment, canVote, commentHeader)
        else if permissionsHierarchy == 'comment'
          actionsPartial(canComment, null, commentHeader)
          actionsPartial(null, canVote, votingHeader)
        else
          actionsPartial(null, canVote, votingHeader)
          actionsPartial(canComment, null, commentHeader)
        t.a '.quiet-button.js-change-permissions', { href: "#" }, ->
          t.span -> t.format 'change-permissions'
      else if isLoggedIn
        actionsPartial(canComment, canVote, 'you-can')
      else
        actionsPartial(canComment, canVote, 'any-trello-user-can')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_about_this_board.coffee